<template>
  <div class="pages">
    <div class="top facab">
      <div class="t-l">{{ $t('main.shopCar') }}</div>
      <div class="t-r">
        <el-input :placeholder="$t('main.search')" v-model="input3" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <div class="content">
      <div class="t-th fac">
        <div class="tl-th1">
          <el-checkbox v-model="checked" @change="selectAllshop">{{ $t('main.SelectAll') }}</el-checkbox>
        </div>
        <div class="tl-th2">{{ $t('main.ProductSpecifications') }}</div>
        <div class="tl-th">{{ $t('main.priceForOne') }}</div>
        <div class="tl-th3">{{ $t('main.totalNum') }}</div>
        <div class="tl-th">{{ $t('main.subTotal') }}</div>
        <div class="tl-th3">{{ $t('main.Manage') }}</div>
      </div>
      <div>
        <div v-if="hasItem" style="color: rgb(153, 153, 153);">
          <div class="t-td fac"  v-for="(item, index) in shoplist" :key="index">
            <div class="tl-th1">
              <el-checkbox v-if="item.kucun == 0" v-model="item.checked" disabled></el-checkbox>
              <el-checkbox v-else v-model="item.checked"></el-checkbox>
            </div>
            <div class="tl-th2 fac" style="padding:1rem 0;">
              <img style="cursor: pointer;" @click="gotoProductDetail(item)" :src="item.productimg" class="tr-img" />
              <div class="td-label">
                <div class="fac lh30" style="color: #333333;">
                  <div style="width: 10rem;">{{ $t('main.product') }}</div>
                  <div style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.type_name}}</div>
                </div>
                <div class="fac lh30" style="color: #333333;">
                  <div style="width: 10rem;">{{ $t('main.partNumber') }}</div>
                  <div style="width: calc(100% - 10rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item)">{{item.product_model}}</div>
                </div>
                <div class="fac lh30" v-for="(itemd, ind) in item.product_info" v-if="itemd.isShow" :key="ind">
                  <div style="width: 10rem">{{ itemd.title }}</div>
                  <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                </div>
                <div class="fac lh30" v-for="(itemd, inds) in item.product_info" v-if="!itemd.isShow && showMore.findIndex(res=>{return res == item.id;}) > -1" :key="inds">
                  <div style="width: 10rem">{{ itemd.title }}</div>
                  <div style="width: calc(100% - 10rem);">{{ itemd.value }}</div>
                </div>
                <div class="fac color-635796" style="cursor: pointer;" @click="handleProductParamsMore(item)">
                  {{ showMore.findIndex(res=>{return res == item.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                  <i :class="showMore.findIndex(res=>{return res == item.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                </div>
              </div>
            </div>
            <div class="tl-th">{{ item.price }}</div>
            <div class="tl-th3">
              <el-input-number
                :label="$t('main.shopCarNum')"
                :min="1"
                v-model="item.number"
                @change="updateQuantity(item)"
              ></el-input-number>
              <div style="color: #999; padding-top: 0.75rem">{{ $t('main.StockNum') }}:{{ item.kucun }}</div>
              <el-button class="mainBtn addInquiryForGoogle" @click="addInquiryToCard(item)">{{ $t('main.addInquiry') }}</el-button>
            </div>
            <div class="tl-th">{{ $t('main.monetaryUnit') }} {{ Math.round( item.number * item.price * 100)/100 }}</div>
            <div class="tl-th3" @click="handleDelete(item.id)" style="cursor:pointer">{{ $t('main.delete') }}</div>
          </div>
        </div>
      </div>
      <div v-if="!shoplist.length" class="no-data">{{ $t('main.noData') }}</div>
      <div class="t-bottom facab">
        <div style="padding-left: 1rem">
          <el-checkbox v-model="checked" @change="selectAllshop">{{ $t('main.SelectAll') }}</el-checkbox>
          <el-button class="mainBtm" @click="handleSelectedToInquiry()" style="margin-left: 1rem;">{{ $t('main.AddAllToInquiry') }}</el-button>
          <span class="blt" style="padding-left: 1rem;cursor:pointer" @click="handleSelectedDelete(1)"
            >{{ $t('main.DeleteSelected') }}</span
          >
          <span class="blt" style="padding-left: 1rem;cursor:pointer" @click="handleSelectedDelete(0)">{{ $t('main.clearShopCar') }}</span>
        </div>
        <div>
          <span
              style="margin-right: 4.25rem"
              v-html="$t('main.chooseShopNum', { num: shoppingnum })">

          </span>
          <span style="margin-right: 2.5rem"
            >{{ $t('main.totalPrice') }}:<span class="color-635796"> {{ $t('main.monetaryUnit') }} {{ totalPrice }}</span></span
          >
          <el-button class="mainBtm" @click="goToSettlement()">{{ $t('main.toSettle') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { readShopcar, Shopcarlist, editShopcar, delShopcar, shoppingCarCountChange } from "@/api/shopcar";
import {
  getProductInfo
} from '@/api/index'
import { placeOrder } from '@/api/shopcar'

import Cookies from 'js-cookie'
import {addInquiry} from "@/api/inquiry";
export default {
  data() {
    return {
      itemId: 1, // to be changed
      input3: '',
      showMore: [],
      value: '',
      checked: true,
      num: 1,
      //购物车list
      shoplist: [],

      //需要传到订单界面的数据
      paramsToOrder: {},
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  methods: {
    //初始化数据
    initData() {
      //请求数据
      var params = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ],
          order: "id desc"
        }
      }
      this.getShopcarlist(params);
      //模拟数据
      // console.log('所有商品信息', this.shoplist)
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    getShopcarlist(params) {
      Shopcarlist(params)
        .then(res => {
          if (res.data.list.length !== 0) {
            this.shoplist = []
            const productType = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
            for (let i = 0; i < res.data.list.length; i++) {
              const nowProductType = productType.find(productType => {
                return productType.id == res.data.list[i].product_info.type_id;
              });
              const singleData = {
                uuid: res.data.list[i].uuid,
                user_id: res.data.list[i].user_id,
                type_id: res.data.list[i].product_info.type_id,
                type_name: nowProductType.name,
                product_id: res.data.list[i].product_id,
                product_info: res.data.list[i].product_info.product_data,
                price: res.data.list[i].price,
                number: res.data.list[i].number,
                site_id: '',
                productimg: res.data.list[i].product_info.thumb,
                kucun: res.data.list[i].product_info.stock,
                id: res.data.list[i].id,
                checked: res.data.list[i].product_info.stock == 0 ? false:true,// 购物车是否选中
                product_model: res.data.list[i].product_info.product_model
                //缺少字段：1，产品图片
              };
              this.shoplist.push(singleData)
            }
          } else {
            this.shoplist = []
          }
        })
        .catch(err => {
          this.shoplist = []
        })
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    goToSettlement() {
      // console.log("this.paramsToOrder.addAdress",this.paramsToOrder.addAdress);
      //判断有没有登录，登录后跳转到结算页面
      if (!Cookies.get('userinfo')) {
        this.$router.push({ name: 'Login', params:{frompath: "shoppingCart"}})
      } else {
        //组装paramsToOrder
        //获取选定的商品信息
        var checkCar = []
        for (var i = 0; i < this.shoplist.length; i++) {
          if (this.shoplist[i].checked == true) {
            checkCar.push(this.shoplist[i])
          }
        }
        this.paramsToOrder.orderInfo = checkCar

        if (this.paramsToOrder.orderInfo.length == 0) {
          this.$message({
            message: this.$t('main.pleaseSelectProduct'),
            type: 'error'
          })
          return
        }
        var productidAndNumArr = []
        for (let i = 0; i < this.paramsToOrder.orderInfo.length; i++) {
          var singlProductandnum = {}
          singlProductandnum.product_id = this.paramsToOrder.orderInfo[i].product_id
          singlProductandnum.number = this.paramsToOrder.orderInfo[i].number
          productidAndNumArr.push(singlProductandnum)
        }
        // orderInfo
        let orderParams = {
          product_id_numbers: productidAndNumArr,
          totalPrice: this.totalPrice,
          totalNumber: this.shoppingnum
        };
        window.sessionStorage.setItem("settlementInfo", JSON.stringify(orderParams));
        this.$router.push({ path: '/addressInformation'})
      }
    },
    updateQuantity(current) {
      // console.log(current.id)
      // todo
      // shoppingCarCountChange().then(res => {
      //
      // })
      this.shoplist.forEach(item => {
        if (current.id == item.id) {
          item.number = current.number;
          editShopcar(item.id, current.number);
        }
      });
    },

    selectAllshop() {
      //设置所有的check状态为true
      for (var j = 0; j < this.shoplist.length; j++) {
        if (this.checked == true) {
          if (this.shoplist[j].kucun == 0) {
            this.shoplist[j].checked = false
          } else {
            this.shoplist[j].checked = true
          }
        } else {
          this.shoplist[j].checked = false
        }
      }
    },
    search() {
      var params = {
        req: {
          where: [
            {
              filed: 'product_info',
              expression: 'LIKE',
              condition: `%${this.input3}%`
            },
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            }
          ]
        }
      };
      this.getShopcarlist(params)
    },
    handleDelete(item) {
      if (item && item.length !== 0) {
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        }).then(() => {
          delShopcar(item.toString()).then(res => {
            if (res.rsp.code == 0) {
              this.$message({
                message: this.$t('main.operationCompletedSuccessfully'),
                type: 'success'
              })
              var params = {
                req: {
                  where: [
                    {
                      filed: 'product_info',
                      expression: 'LIKE',
                      condition: `%${this.input3}%`
                    },
                    {
                      "condition": Cookies.get("siteInfo"),
                      "filed": "site_id",
                      "expression": "="
                    }
                  ]
                }
              }
              this.checked = false
              this.getShopcarlist(params);
              this.$store.dispatch("setCarNum", true);
            } else {
              this.$message({
                message: res.rsp.msg,
                type: 'error'
              })
            }
          })
        }).catch(() => {
          // 用户取消删除
        });
      } else {
        this.$message({
          message: this.$t('main.pleaseSelectProduct'),
          type: 'error'
        })
      }
    },
    handleSelectedDelete(type) {
      var choosedArr = []
      for (var i = 0; i < this.shoplist.length; i++) {
        if (type) {
          if (this.shoplist[i].checked) {
            choosedArr.push(this.shoplist[i].id)
          }
        } else {
          choosedArr.push(this.shoplist[i].id)
        }
      }
      this.handleDelete(choosedArr);
    },
    addInquiryToCard(item) {
      let params = {
        req: {
          product_ids: [
            {
              product_id: item.product_id,
              number: item.number || 1
            }
          ]
        }
      };
      addInquiry(params).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch("setInquiryNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    handleSelectedToInquiry() {
      const product_ids = [];
      const inquirySedPIds = [];
      for (var i = 0; i < this.shoplist.length; i++) {
        if (this.shoplist[i].checked) {
          product_ids.push({
            product_id: this.shoplist[i].product_id,
            number: this.shoplist[i].number || 1
          });
          inquirySedPIds.push(this.shoplist[i].product_id);
        }
      }

      if (product_ids && product_ids.length !== 0) {
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        }).then(() => {
          let params = {
            req: {
              product_ids: product_ids
            }
          };

          addInquiry(params).then(res => {
            if (res.rsp.code === 0) {
              this.$store.dispatch("setInquiryNum", true);
              this.$message({
                message: this.$t('main.operationCompletedSuccessfully'),
                type: "success"
              });

              window.sessionStorage.setItem("inquirySedPIds", JSON.stringify(inquirySedPIds));
              this.$router.push({ path: '/inquiry'})

            } else {
              this.$message({
                message: res.rsp.msg,
                type: 'error'
              })
            }
          })
        }).catch(() => {
          // 用户取消删除
        });
      } else {
        this.$message({
          message: this.$t('main.pleaseSelectProduct'),
          type: 'error'
        })
      }
    },
    handleCheckboxChange(item) {
      // console.log(item);
    }
  },
  created() {
    this.initData()
  },
  computed: {
    totalPrice() {
      let total = 0
      this.shoplist.forEach(item => {
        if (item.checked) {
          total += item.number * item.price
        }
      })
      return Math.round( total * 100)/100
    },
    shoppingnum() {
      let num = 0
      this.shoplist.forEach(item => {
        if (item.checked) {
          num += item.number
        }
      })
      return num
    },
    hasItem() {
      return this.num != 0
    }
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.initData()
    },
    num(value) {
      // 修改购物车的数量和总金额
      editShopcar(this.itemId, value).then(res => {
        // console.log(res)
      })
    }
  }
  //TOOD 监听对象里面的内容
}
</script>

<style lang="less" scoped>
.pages {
  min-height: 100%;
  background-color: #fff;
  .top {
    .t-l {
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #635796;
      line-height: 2.25rem;
    }
    .t-c {
      height: 2.5rem;
      border: 1px solid #cccccc;
      border-radius: 4px;
      ::v-deep .el-input-group__append,
      .el-input-group__prepend {
        background-color: #fff;
        border: 0;
        padding: 0 10px;
      }
      ::v-deep .el-input__inner {
        height: 2.375rem;
        line-height: 2.375rem;
        border: 0;
      }
    }
  }
  .content {
    .t-th {
      width: 100%;
      background: #f2f2f2;
      border: 1px solid #e6e6e6;
      height: 3.75rem;
      line-height: 3.75rem;
    }
    .t-td {
      padding: 1rem 0;
      border: 1px solid #f5f5f5;
      .tl-th3 {
        .el-input-number{
          max-width: 130px;
        }
      }
      .tr-img {
        height: 4.8rem;
        margin-right: 1.5rem;
      }
      .td-label {
        text-align: left;
      }
    }
    .t-td:nth-child(even) {
      background: #f2f2f2;
    }

    .no-data {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .t-bottom {
      margin-top: 0.5rem;
      height: 3.75rem;
      line-height: 3.75rem;
      border: 1px solid #e6e6e6;
      .blt {
        padding-left: 1rem;
        color: #666666;
      }
      .mainBtm {
        width: 10rem;
        height: 3.75rem;
        background: #635796;
        color: #ffffff;
      }
    }
    .t-td + .t-td {
      margin-top: 0.5rem;
    }
    .tl-th1 {
      width: 5rem;
      padding-left: 1rem;
    }
    .tl-th2 {
      width: calc(50% - 5rem);
      text-align: center;
    }
    .tl-th3 {
      width: 15%;
      text-align: center;
    }
    .tl-th {
      width: 10%;
      text-align: center;
    }
    .lh30 {
      line-height: 1.5rem;
    }
  }

  /deep/ .el-select .el-input .el-select__caret {
    font-size: 1rem;
    height: 2.375rem;
    line-height: 2.375rem;
  }
  /deep/ .el-input-number__decrease,
  /deep/ .el-input-number__increase {
    bottom: 1px;
  }
  .mainBtn {
    width: 86px;
    margin-top: 10px;
    height: 32px;
    background: #635796;
    border-radius: 4px;
    color: #ffffff;
    padding: 0;
  }
  @media screen and (max-width: 1400px) {
    .top {
      padding: 3.25rem 2% 1.5rem;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .top {
      padding: 3.25rem 10% 1.5rem;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .top {
      padding: 3.25rem 15% 1.5rem;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }
}
</style>
